import { Injectable, EventEmitter, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './api.service';
import { Lang, FVEnviroment } from '../models';

@Injectable()
export class LanguageService {
  defaultLanguage: Lang;
  languageChanged: EventEmitter<Lang> = new EventEmitter();

  private _firstTime = true;
  private _languages: Lang[];
  private _language: Lang = this.loadSavedLanguage() || this.defaultLanguage;
  private _translations: Object = {};

  constructor(
    @Inject('enviroment') private enviroment: FVEnviroment,
    private translate: TranslateService,
    private apiService: ApiService,
  ) {
    this.defaultLanguage = enviroment.defaultLanguage || new Lang('English', 'en', 'fa fa-flag');
    this._languages = this.enviroment.languages || [];
    this.translate.setDefaultLang(this.defaultLanguage.Code);
  }

  loadSavedLanguage() {
    return JSON.parse(localStorage.getItem('language')) || false;
  }

  getTranslate(key: string = '') {
    return new Promise((resolve, reject) => {
      this.translate.get(key.toLowerCase()).subscribe(resolve, reject);
    });
  }

  addTranslate(langCode: string, transation: Object) {
    this._translations[langCode] = transation;
  }

  get languages(): Promise<Lang[]> {
    return Promise.resolve(this._languages);
  }

  get language(): Lang {
    return this._language;
  }

  set language(lang: Lang) {
    this.setupLanguage(lang);
  }

  private setupLanguage(lang: Lang) {
    if (!this.language || !this.language.Code) {
      this._language = lang;
    }
    this.translate.use(this.language.Code);
    this.translate.addLangs([this.language.Code]);
    const translation = this._translations[lang.Code];

    const handleTranslation = (_translation) => {
      this.translate.setTranslation(this.language.Code, _translation);
      localStorage.setItem('language', JSON.stringify(lang));
      if (lang.Code !== this._language.Code) {
        this._language = lang;
        this.languageChanged.emit(lang);
      }
    };
    if (translation) {
      handleTranslation(translation);
      return;
    }
    this.apiService.get('translate', [this.language.Code]).then((translations) => {
      handleTranslation(translations);
    });
  }

}
